module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0912-6341e77823fce4ee9a7d9f93d74c3fdb.jpg";